function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { Path } from "react-native-svg";
var SvgTechnicalSupport = function SvgTechnicalSupport(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement(Path, {
    stroke: props.fillLine,
    d: "M6.5 20A2.5 2.5 0 0 0 9 17.5l4.823-4.823a4.5 4.5 0 0 0 5.854-5.854L16.5 10 14 7.5l3.177-3.177a4.5 4.5 0 0 0-5.854 5.854L6.5 15a2.5 2.5 0 0 0 0 5Z"
  }), /*#__PURE__*/React.createElement(Path, {
    stroke: props.fillLine,
    d: "M6.5 18a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1Z"
  }));
};
export default SvgTechnicalSupport;